import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { useId as n } from "react";
//#region src/icons/empty-state.tsx
function r(r) {
	let i = n();
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 160 166",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": "true",
		focusable: "false",
		...r,
		children: [
			/* @__PURE__ */ t("g", {
				id: `${i}-empty-state-backdrop`,
				children: [
					/* @__PURE__ */ e("g", {
						filter: `url(#${i}-filter0_d_9913_488)`,
						children: /* @__PURE__ */ e("rect", {
							x: "20",
							y: "33.6387",
							width: "98",
							height: "98",
							rx: "16",
							transform: "rotate(-8 20 33.6387)",
							fill: "var(--color-system-primary-200, #b9e6fd)"
						})
					}),
					/* @__PURE__ */ e("circle", {
						cx: "37.2009",
						cy: "42.1735",
						r: "3",
						transform: "rotate(-8 37.2009 42.1735)",
						fill: "white",
						fillOpacity: "0.5"
					}),
					/* @__PURE__ */ e("circle", {
						cx: "47.1037",
						cy: "40.7818",
						r: "3",
						transform: "rotate(-8 47.1037 40.7818)",
						fill: "white",
						fillOpacity: "0.5"
					}),
					/* @__PURE__ */ e("circle", {
						cx: "57.0064",
						cy: "39.3901",
						r: "3",
						transform: "rotate(-8 57.0064 39.3901)",
						fill: "white",
						fillOpacity: "0.5"
					}),
					/* @__PURE__ */ e("rect", {
						x: "36.0394",
						y: "55.4645",
						width: "70",
						height: "5",
						rx: "2.5",
						transform: "rotate(-8 36.0394 55.4645)",
						fill: "white",
						fillOpacity: "0.5"
					}),
					/* @__PURE__ */ e("rect", {
						x: "37.2919",
						y: "64.377",
						width: "34",
						height: "5",
						rx: "2.5",
						transform: "rotate(-8 37.2919 64.377)",
						fill: "white",
						fillOpacity: "0.5"
					})
				]
			}),
			/* @__PURE__ */ t("g", {
				clipPath: `url(#${i}-empty-state-front-card-clip)`,
				children: [/* @__PURE__ */ e("rect", {
					x: "49.0327",
					y: "38.1547",
					width: "98",
					height: "98",
					rx: "16",
					transform: "rotate(8.7323 49.0327 38.1547)",
					fill: "var(--color-bg-primary, #ffffff)"
				}), /* @__PURE__ */ e("use", {
					href: `#${i}-empty-state-backdrop`,
					filter: `url(#${i}-empty-state-glass-blur)`
				})]
			}),
			/* @__PURE__ */ e("g", {
				filter: `url(#${i}-filter1_d_9913_488)`,
				children: /* @__PURE__ */ e("rect", {
					x: "49.0327",
					y: "38.1547",
					width: "98",
					height: "98",
					rx: "16",
					transform: "rotate(8.7323 49.0327 38.1547)",
					fill: "var(--color-system-primary-50, #f1f9fe)",
					fillOpacity: "0.6",
					shapeRendering: "crispEdges"
				})
			}),
			/* @__PURE__ */ t("defs", { children: [
				/* @__PURE__ */ e("filter", {
					id: `${i}-empty-state-glass-blur`,
					x: "-20%",
					y: "-20%",
					width: "140%",
					height: "140%",
					colorInterpolationFilters: "sRGB",
					children: /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "3" })
				}),
				/* @__PURE__ */ e("clipPath", {
					id: `${i}-empty-state-front-card-clip`,
					children: /* @__PURE__ */ e("rect", {
						x: "49.0327",
						y: "38.1547",
						width: "98",
						height: "98",
						rx: "16",
						transform: "rotate(8.7323 49.0327 38.1547)"
					})
				}),
				/* @__PURE__ */ t("filter", {
					id: `${i}-filter0_d_9913_488`,
					x: "-8.73091",
					y: "-4.73121",
					width: "168.147",
					height: "168.147",
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "4" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "15.4" }),
						/* @__PURE__ */ e("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.360947 0 0 0 0 0.509097 0 0 0 0 0.586538 0 0 0 0.1 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_9913_488"
						}),
						/* @__PURE__ */ e("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_9913_488",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ t("filter", {
					id: `${i}-filter1_d_9913_488`,
					x: "22.7959",
					y: "30.7961",
					width: "134.46",
					height: "134.459",
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ e("feFlood", {
							floodOpacity: "0",
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ e("feOffset", { dy: "4" }),
						/* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "6.8" }),
						/* @__PURE__ */ e("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ e("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.263683 0 0 0 0 0.380989 0 0 0 0 0.442308 0 0 0 0.1 0"
						}),
						/* @__PURE__ */ e("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_9913_488"
						}),
						/* @__PURE__ */ e("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_9913_488",
							result: "shape"
						})
					]
				})
			] })
		]
	});
}
//#endregion
export { r as EmptyStateIcon };
